// extracted by mini-css-extract-plugin
module.exports = {"textArea":"RealizationTextArea_textArea__2UAkx"};